/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/**
 * Scroll to Loox reviews section when rating stars are clicked
 * Uses custom easing for ultra-smooth animation
 */
function switchToReviews() {
  // Try to find the reviews section by multiple selectors
  const reviewsSection = document.querySelector('#looxReviews') ||
                        document.querySelector('[id*="loox_reviews"]') ||
                        document.querySelector('.loox-widget');

  if (reviewsSection) {
    // Get header height for offset
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const offset = headerHeight + 20; // Add 20px extra spacing

    // Calculate target position
    const elementPosition = reviewsSection.getBoundingClientRect().top;
    const targetPosition = elementPosition + window.pageYOffset - offset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 1200; // 1.2 seconds for smoother scroll
    let startTime = null;

    // Easing function for smooth animation (easeInOutCubic)
    function easeInOutCubic(t) {
      return t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    // Animation function
    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);

      window.scrollTo(0, startPosition + (distance * ease));

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        console.log('[Reviews Scroll] Scrolled to reviews section');
      }
    }

    // Start animation
    requestAnimationFrame(animation);
  } else {
    console.warn('[Reviews Scroll] Reviews section not found on this page');
  }
}

// Make function available globally
window.switchToReviews = switchToReviews;
